import { render, staticRenderFns } from "./Keywis.vue?vue&type=template&id=5c850f66&"
import script from "./Keywis.vue?vue&type=script&lang=ts&"
export * from "./Keywis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports